import core_values_1 from "/public/images/icon/core-values-1.png";
import core_values_2 from "/public/images/icon/core-values-2.png";
import core_values_3 from "/public/images/icon/core-values-3.png";

export const career_data = [
  {
    id: 1,
    position: "Admin",
    title: "Teller",
    desc: "<ul>\n" +
        "      <li>Gender: Pria / Wanita</li>\n" +
        "      <li>Usia Minimum: 22 tahun</li>\n" +
        "      <li>Pendidikan terakhir: Fresh graduate welcome</li>\n" +
        "      <li>Komunikatif</li>\n" +
        "      <li>Berpenampilan menarik</li>\n" +
        "      <li>Jujur</li>\n" +
        "    </ul>\n",
    link: "/career-single",
  },
  {
    id: 2,
    position: "Management",
    title: "Accountant",
    desc: "<ul>\n" +
        "  <li>Gender: Pria / Wanita</li>\n" +
        "  <li>Usia Minimum: 25 tahun</li>\n" +
        "  <li>Pendidikan terakhir: S1 Akuntansi</li>\n" +
        "  <li>Komunikatif</li>\n" +
        "  <li>Berpenampilan menarik</li>\n" +
        "  <li>Jujur</li>\n" +
        "  <li>Berpengalaman di bidang akuntansi minimal 2–3 tahun</li>\n" +
        "</ul>\n",
    link: "/career-single",
  },
  {
    id: 3,
    position: "Developer",
    title: "Backend Web Developer",
    desc: "<ul>\n" +
        "  <li>Gender: Pria / Wanita</li>\n" +
        "  <li>Usia Minimum: 25 tahun</li>\n" +
        "  <li>Pendidikan terakhir: S1 Computer</li>\n" +
        "  <li>C# (Backend) and MSSQL (Database)</li>\n" +
        "  <li>Berpengalaman coding website minimal 1 tahun</li>\n" +
        "</ul>\n",
    link: "/career-single",
  },
  {
    id: 4,
    position: "Developer",
    title: "Frontend Web Developer",
    desc: "<ul>\n" +
        "  <li>Gender: Pria / Wanita</li>\n" +
        "  <li>Usia Minimum: 25 tahun</li>\n" +
        "  <li>Pendidikan terakhir: S1 Computer</li>\n" +
        "  <li>ReactJS</li>\n" +
        "  <li>Berpengalaman coding website minimal 1 tahun</li>\n" +
        "</ul>\n",link: "/career-single",
  },
];

export const core_values_data = [
  {
    id: 1,
    icon: core_values_1,
    title: "Teknologi",
    desc: "Menggunakan teknologi transaksi modern untuk kemudahan dan keamanan nasabah",
  },
  {
    id: 2,
    icon: core_values_2,
    title: "Layanan",
    desc: "Memberikan layanan penukaran valuta asing yang cepat, transparan dan berstandar tinggi",
  },
  {
    id: 3,
    icon: core_values_3,
    title: "Regulasi dan Standar",
    desc: "Menjaga kepatuhan penuh terhadap regulasi Bank Indonesia dan standar anti pencucian uang",
  },
];
